export const reduxKey = '@@Dreamup';
export const ANON_LANDING_DEVIATION_STREAM_ID = 'ANON_DREAMUP_LANDING_DEVIATIONS';
